/*
 * Copyright (c) 2024. Haodong JU
 */

import { storageGet, storagePost } from '@/model/dataLayer/api/storage/inventoryUtils'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export async function saveResource (resource) {
  return await storagePost('resource/save', resource)
}

export async function getAllResource () {
  return await storageGet('resource/listByShopId/' + await getCurrentDeviceId(), {})
}

export async function deleteResource (id) {
  return await storagePost('resource/delete/' + id, {})
}
